import React, { Component } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import Serverurl from './Apiurl';
import Select from '@mui/material/Select';
//import { styled } from '@mui/material/styles';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import RadioGroup from '@mui/material/RadioGroup';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow'; 
import TableCell from '@mui/material/TableCell';
import FormGroup from '@mui/material/FormGroup';
import Radio, { RadioProps } from '@mui/material/Radio';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import { styled } from '@mui/system';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});
const useStyles = styled((theme) => ({
  root: {
    width: 500,
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
    minWidth: 120,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));
export default class Adminoption extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect:false,pagename:'',ao_id:0,type:'',ao_description: '',adminarray:[],label: 'Select Name',desc: '',
      aoid:'',ids:'',textcountmin:0,errormessage:'',
textcountmax:200, successMessage: '',submitbtn:'save',BusiEmailData:[],
      showSuccessMessage: false,sendemailid:'',ind:0,openbox2:2, showOTPInput: false,
  enteredOTP: '',
    };
	 this.updateDonenewParent = this.updateDonenewParent;
  }
updateDonenewParent = (childData) =>{
let strvalues=childData
const updatedArrays=[...this.state.BusiEmailData];
		  updatedArrays[0].bs_value = childData ;
		  this.setState({BusiEmailData:updatedArrays,sendemailid:childData},()=>{
		  });
}
componentWillMount() {
	document.title = "Admin Option";
	if(localStorage.getItem("ISIuserid")==null)
		  {
		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
		 	this.apicall();		
		  }
		  else{
		this.PageAccessCheckApi();
		  }
	}
		 this.props.parentdasCallback(
            "Document emails ~"
        );
	this.apicall();
}
PageAccessCheckApi() {
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=20')
  .then(resp => {
	  let strreturn=resp.data;
      if (strreturn!==0) {
       	this.apicall();	
      } else {
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
  });
} onclickCancel = (e) => {
	this.setState({redirect:true,pagename:'/settings'});
 }
  apicall ()  {
	  let strsettings=[];
    axios.get(localStorage.getItem("ISIurl")+'ajaxadminoption.php?action=list&ao_type=3&ao_cmp_id='+localStorage.getItem("ISIcmpid"))
      .then((response) => {
		 var strararay=response.data;
		  const items=[];
		 strararay.map((row, i) => { 
		let strval="1";
			 if(i===0)
			 {
		   strval="0";
			 }
		  const items = {ao_id:row.ao_id,ao_description:row.ao_description,ao_name:row.ao_name,isdisplay:strval,}
        strsettings.push(items)
      })
	 this.setState({ 
  adminarray: strsettings, 
});
	   this.GetBusinessSetting();
	  },()=>{
	  })
  };
  myChangeHandler = (firstrow) => event  => { 
  let nam = event.target.name;
  let val = event.target.value;
    const updatearray = [...this.state.adminarray]
	if(nam==="ao_description")
	{
		    if (val.length <= this.state.textcountmax) {
            this.setState({
                [nam]: val,           
                textcountmin: val.length 
            });
        }
		updatearray[firstrow].ao_description = val
	}
      this.setState({ adminarray:updatearray }); 
 }
handleSelectChange = (index) => {
   const updatearray = [...this.state.adminarray]
 updatearray.map((rowssub,j) => {
                      rowssub.isdisplay = "1" ;
                                 });
  if(updatearray[index].isdisplay === "0") {
	updatearray[index].isdisplay = "1" 
  } 
  else {
    updatearray[index].isdisplay = "0" 
  }
   this.setState({adminarray:updatearray}); 
}
    handleSubmit = (event) => {
    event.preventDefault();
	 let optionsBusValue=this.state.BusiEmailData;
    let sep1 = '';
    let optionValues = '';
    const formData = new FormData();
    formData.append('action', 'BulkUpdate');
    let optionsVal = this.state.adminarray;
    optionsVal.forEach(eachval => {
      if(eachval.ao_id !== ""){  
        optionValues += sep1 + eachval.ao_id + "~" + eachval.ao_description; 
        sep1 = '`'
      }
    });
let optionValuesBus="";
let sep2="";
optionsBusValue.forEach(eachval => {
		 optionValuesBus=optionValuesBus+sep2+eachval.bs_id+"~"+eachval.bs_value;
		 sep2="`"
	   });
    formData.append('ao_description', optionValues);
    formData.append('businesssetting', optionValuesBus);
    formData.append('bs_cmp_id', localStorage.getItem("ISIcmpid"));
    formData.append('bs_page', 2);
    formData.append('userid', localStorage.getItem("ISIuserid"));
    console.log(optionValuesBus);
    axios.post(localStorage.getItem("ISIurl")+'ajaxadminoption.php', formData)
      .then((res) => {
      this.setState({
            btndisabled: false,
            submitbtn: "Save",
            errormessage: "Updated Successfully", 
            erropen: true,
            successMessage: 'Admin Option updated successfully!',
            showSuccessMessage: true,
          });
      })
  };
GetBusinessSetting() {
  let strsettings = [];
  axios
    .get(localStorage.getItem("ISIurl") + 'ajaxbusinesssetting.php?action=getall&bs_page=2&bs_cmp_id='+localStorage.getItem("ISIcmpid"))
    .then(resp => {
      if (resp.data) {
        this.setState({
          BusiEmailData: resp.data,
        }, () => {
          console.log(this.state.BusiEmailData);
        });
      } else {
        this.setState({ BusiEmailData: [] });
      }
    })
}
handleErrorclose=(event)=>{
	this.setState({erropen: false});  
  }
HandleCustomer= (id, rowsd) => (event) => {
  const value = event.target.value; 
  const updatedArray = [...this.state.BusiEmailData]; 
  updatedArray[rowsd].bs_value = value; 
  this.setState({ BusiEmailData: updatedArray }, () => {
    console.log('onselect',this.state.BusiEmailData)
  });
};
  render() {
    if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />;
    }
    return (
	<React.Fragment> 
	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.errortype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
	  <div className="emaildoc">
	 <div className="businesssetting">
    <div className="leftpagetitle">
    </div>
    <div className="pagecontentright">
      <Table>
        {this.state.BusiEmailData.map((item, index) => (
          <React.Fragment key={index}>
		{item.bs_id === "29" && (
              <TableRow>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
					width: { xs: "200px", md: "400px" },
                  }}
                >
                  <h6>{item.bs_title}</h6>
				 <p>{item.bs_value}</p>
                </TableCell>
                <TableCell>
           <div className="emailchangbtn">
			<p><Button
			 type="submit"
             halfWidth
             variant="contained"
             color="primary"
            id="submit"
            className="frmSecondarybtn"
            onClick={()=>{this.refs.ChangeEmail.handleaddfileClose(item.bs_id,index)}}
			>Change</Button> <Button
			type="submit"
             halfWidth
             variant="contained"
             color="primary"
            id="submit"
            className="frmSecondarybtn"
             onClick={()=>{this.refs.ChangeEmail.HandleRemoveEmailOpen(item.bs_id,index)}}
			>Reset</Button></p>
			</div>
                </TableCell>
              </TableRow>
            )}
          </React.Fragment>
        ))}
      </Table>
    </div>
    <div className="clear"></div>
  </div>
	 <div className="businesssetting">
    <div className="leftpagetitle">
    </div>
    <div className="pagecontentright">
      <Table>
        {this.state.BusiEmailData.map((item, index) => (
          <React.Fragment key={index}>
            {item.bs_id === "30" && (
              <TableRow>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
					width: { xs: "200px", md: "400px" },
                  }}
                >
                  <h6>{item.bs_title}</h6>
				   <p>When sending a document by email we can send you a copy. Do you want us to do this?</p>
                </TableCell>
                <TableCell>
                  <FormControl className="preference">
                    <RadioGroup
                      value={item.bs_value}
                      onChange={this.HandleCustomer(item.bs_id, index)}
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: 18,
                          color: "green",
                        },
                      }}
                    >
<FormControlLabel
  value="1"
  control={<Radio />}
  label={'Yes - Always send a copy of the email to ' + localStorage.getItem("ISIUsername")}
/>
                   <FormControlLabel
  value="2"
  control={<Radio />}
  label="No - I don't want to receive a copy of that email"
/>
                    </RadioGroup>
                  </FormControl>
                </TableCell>
              </TableRow>
            )}
		{item.bs_id === "31" && (
              <TableRow>
                <TableCell
                  sx={{
                    verticalAlign: "middle",
					width: { xs: "200px", md: "400px" },
                  }}
                >
                  <h6>{item.bs_title}</h6>
				  <p>When sending an email we can automatically include a pdf version of your invoice, quote, credit note or estimate as an attachment. Do you want us to do this?</p>
                </TableCell>
                <TableCell>
                 <FormControl className="preference">
                    <RadioGroup
                      value={item.bs_value}
                      onChange={this.HandleCustomer(item.bs_id, index)}
                      sx={{
                        "& .MuiSvgIcon-root": {
                          fontSize: 18,
                          color: "green",
                        },
                      }}
                    >
<FormControlLabel
  value="1"
  control={<Radio />}
  label="Yes - Always attach the document as a PDF"
/>
                   <FormControlLabel
  value="2"
  control={<Radio />}
  label="No - I can attach documents to an email when needed."
/>
                    </RadioGroup>
                  </FormControl>
                </TableCell>
              </TableRow>
            )}
          </React.Fragment>
        ))}
      </Table>
    </div>
    <div className="clear"></div>
  </div>
	  </div>
	  <div className="emaildoc">
      <div className="page-container">
        <div className="mainadoptionbg">
          {this.state.adminarray.map((item,index) => {
            return (
              <div key={index}>
                  <div 
                      className="listitemsleft"
                      onClick={() => {
                      this.handleSelectChange(index);
                    }}
                  >
				   {item.ao_name}
                  </div>
                   <div 
                    className="listitemsright"> <div 
                    className="inputcontrolemail">
            {item.isdisplay==="0" && (
                      <TextField
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        multiline
                        rows={6}
                        name="ao_description"
                        onChange={this.myChangeHandler(index)}
                        value={item.ao_description}
                        autoComplete="ao_description"
                      />
			)} 
			 {item.isdisplay==="0" && ( <span >You have used {this.state.textcountmin} of { this.state.textcountmax} characters</span> )}
			<div className="maxlength">
 </div>
						</div>
						</div>	
			 <div className="clear"></div>
              </div>            
            )
          })}
        </div>
		<div className="message">
			<h2>Where is this message used?</h2>
			<p>When you email sales Quotes, we will put this text in this Message field. You can customize it before sending it to the customer</p>
			</div>
<div className="clear"></div>
</div>
		 <div className="savebtn">	
        <Button
          type="submit"
          halfWidth
          variant="contained"
          color="primary"
          id="submit"
          className="frmSecondarybtn"
          onClick={this.handleSubmit}
          key="submitButton"
		  disabled={this.state.btndisabled}
        >
		{this.state.submitbtn}
        </Button>
		&nbsp;&nbsp;&nbsp;
		<Button variant="contained" className="frmthirdbtn " onClick={this.onclickCancel}>
Cancel
</Button>
</div>
      </div>
<ChangeEmail 
  ref="ChangeEmail" 
  invoiceupdateDone={this.updateDonenewParent}
  emailid={this.state.sendemailid}
/>
	  </React.Fragment>
    );
  }
}
 export class ChangeEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      btntext: 'Continue',
      addopen: false,
      curentemailid: '',
      box: 0,
      btnremovetxt: 'Remove',
      Emaildata: [],
      newemailid: '',
      btndisabled: false,
      errormessage: '',
      erropen: false,
      indx: '',
      id: '',
      showOTPInput: false,
      enteredOTP: '',
    }
  }

  handleMailpopEvent = (e) => {
    this.setState({ addopen: !this.state.addopen });
  }

  myChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;
    this.setState({ [nam]: val });
  }

  handleErrorclose = (event) => {
    this.setState({ erropen: false });
  }

  handleaddfileClose = (val, va2) => {
    this.setState({
      addopen: !this.state.addopen,
      curentemailid: this.props.emailid,
      box: 1,
      showOTPInput: false,
      enteredOTP: '',
      newemailid: '',
      btntext: 'Continue',
      btndisabled: false
    });
  }

  HandleRemoveEmailOpen = (val, val2) => {
    this.setState({ addopen: !this.state.addopen, box: 2 });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const { showOTPInput, newemailid } = this.state;
    const remail = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;

    if (!remail.test(newemailid)) {
      this.setState({ errormessage: "Please Enter Valid Email Id", erropen: true });
      return false;
    }

    if (showOTPInput) {
      // If OTP input is showing, now we verify
      this.handleVerifyOTP();
      return;
    }

    // Generate OTP
    const formData = new FormData();
    formData.append('action', 'generateOTP');
    formData.append('newemail', newemailid);
    formData.append('bs_cmp_id', localStorage.getItem("ISIcmpid"));

    axios.post(localStorage.getItem("ISIurl") + 'ajaxbusinesssetting.php', formData)
      .then(res => {
        if (res.data.status === 'success') {
          //console.log("Generated OTP:", res.data.otp);
          // For local testing only, remove in production
          //alert("Generated OTP (local test): " + res.data.otp);

          this.setState({
            showOTPInput: true,
            btntext: 'Verify OTP',
            btndisabled: false
          });
        } else {
          this.setState({ errormessage: res.data.message, erropen: true });
        }
      });
  }

  handleVerifyOTP = () => {
    const formData = new FormData();
    formData.append('action', 'verifyOTP');
    formData.append('newemail', this.state.newemailid);
    formData.append('otp', this.state.enteredOTP);
    formData.append('bs_cmp_id', localStorage.getItem("ISIcmpid"));

    axios.post(localStorage.getItem("ISIurl") + 'ajaxbusinesssetting.php', formData)
      .then(res => {
        if (res.data.status === 'success') {
          this.props.invoiceupdateDone(this.state.newemailid);
          this.setState({
            showOTPInput: false,
            addopen: false,
            enteredOTP: '',
            newemailid: '',
            btntext: 'Continue',
            btndisabled: false
          });
        } else {
          this.setState({ errormessage: res.data.message, erropen: true });
        }
      });
  }

  handleOTPChange = (event) => {
    this.setState({ enteredOTP: event.target.value });
  }

  render() {
    return (
      <React.Fragment>
        <Dialog
          open={this.state.addopen}
          onClose={this.handleMailpopEvent}
          fullWidth={true}
          maxWidth="md"
          sx={{ maxWidth: '950px', margin: 'auto' }}
        >
          <p>
            <Collapse in={this.state.erropen}>
              <Alert
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => { this.handleErrorclose(); }}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                } severity="error"
              >
                {this.state.errormessage}
              </Alert>
            </Collapse>
          </p>
          <DialogTitle id="form-dialog-title" className="dialoghead">
            {this.state.box === 1 && (<div>Change Email Reply Address</div>)}
            {this.state.box === 2 && (<div>Remove Email Reply Address</div>)}
            <div className="closepricon" onClick={this.handleMailpopEvent}><CloseIcon /></div>
          </DialogTitle>
          <DialogContent>
            {this.state.box === 1 && (
              <React.Fragment>
                <p>When we send emails on your behalf, and a recipient responds, this is the email address their replies go to.</p>
                <p>This setting will apply to all emails we send on behalf of Baawarchi Imports Inc..
                  Email Reply Address
                </p>
                <div className="emailtxtbox">
                  <p><b>Email Reply Address</b></p>
                  <p><TextField
                    name="newemailid"
                    value={this.state.newemailid}
                    onChange={this.myChangeHandler}
                    style={{ width: '50%' }}
                    className="txtbox"
                  />
                  </p>
                </div>

                {this.state.showOTPInput && (
                  <>
                    <p>Please enter the OTP sent to {this.state.newemailid}</p>
                    <TextField
                      name="otp"
                      value={this.state.enteredOTP}
                      onChange={this.handleOTPChange}
					  className="txtbox"
                      style={{ width: '50%', marginBottom: "30px" }}
                    />
                  </>
                )}

                <p>Your current reply address, <b>{this.state.curentemailid}</b>, will be used until this one is verified.</p>
                <p><b>What happens next?</b></p>
                <p>We'll send an email to the new reply address with a verification code, so you'll need access to this mailbox.</p>

                <div className="actionbtns">
                  <div className="cancelbtn">
                    <Button
                      variant="contained"
                      className="frmthirdbtn"
                      onClick={this.handleaddfileClose}
                    >
                      Cancel
                    </Button>
                  </div>
                  <div className="savebtn">
                    <Button
                      disabled={this.state.btndisabled}
                      variant="contained"
                      className="frmSecondarybtn"
                      onClick={this.handleSubmit}
                    >
                      {this.state.btntext}
                    </Button>
                  </div>
                  <div className="clear"></div>
                </div>
              </React.Fragment>
            )}

            {this.state.box === 2 && (
              <React.Fragment>
                <p><b>If you remove this email reply address...</b></p>
                <p>When emails are sent directly through Accounting, and a recipient replies, their reply will go to the email address of the user who sent the original email.</p>
                <p>This setting will apply to everyone who logs in to Baawarchi Imports Inc..</p>
                <p>Are you sure you want to remove the email reply address?</p>
                <div className="actionbtns">
                  <div className="cancelbtn">
                    <Button
                      variant="contained"
                      className="frmthirdbtn"
                      onClick={this.handleaddfileClose}
                    >
                      Cancel
                    </Button>
                  </div>
                  <div className="savebtn">
                    <Button disabled={this.state.btndisabled}
                      variant="contained"
                      className="frmSecondarybtn"
                      onClick={this.handleSubmit}
                    >
                      {this.state.btnremovetxt}
                    </Button>
                  </div>
                  <div className="clear"></div>
                </div>
              </React.Fragment>
            )}
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}